import React from "react";

function NotFound() {
  return (
    <div>
      <h1> PAGE NOT FOUND</h1>
      <p className='lead'> page you are hooking for is not founded</p>
    </div>
  );
}

export default NotFound;
